import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-word-plugin',
  templateUrl: './word-plugin.component.html',
  styleUrls: ['./word-plugin.component.scss']
})
export class wordpluginComponent implements OnInit, AfterViewInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('MS Word外掛程式下載-Trinka免費文法檢查工具');
    this.metaTagService.updateTag({ name: 'description', content: '微軟Word的Trinka外掛程式使有效的寫作變得前所未有的簡單。Trinka會自動檢查您的寫作，並在您熟悉的Word應用程式中進行修改。立即免費下載Trinka。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '高級文法檢查，拼寫檢查工具，免費文法檢查，學術寫作助手' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'MS Word外掛程式下載-Trinka免費文法檢查工具' });
    this.metaTagService.updateTag({ property: 'og:description', content: '微軟Word的Trinka外掛程式使有效的寫作變得前所未有的簡單。Trinka會自動檢查您的寫作，並在您熟悉的Word應用程式中進行修改。立即免費下載Trinka。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/wordplugin' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/wordplugin' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../assets/js/wisepop.js', function () { });
      $.getScript('../../../assets/js/about_us_testimonial_silders.js', function () { });
      if (navigator.userAgent.indexOf("WOW64") != -1 ||
        navigator.userAgent.indexOf("Win64") != -1) {
        document.getElementById("windowInfo64bit").innerHTML = '<a  style="color:#FFF" href="https://s3.amazonaws.com/trinka-word-plugin/64bit/Trinka.Installer.msi" target="_blank"><img src="../../../assets/images/whitePaper_download.png" alt="whitepaper download" style="width: 26px; margin: -6.5px 10px 0 0;"> 現在下載</a>';
      } else {
        document.getElementById("windowInfo64bit").innerHTML = '<a style="color:#FFF" href="https://s3.amazonaws.com/trinka-word-plugin/32bit/Trinka.Installer.msi" target="_blank"><img src="../../../assets/images/whitePaper_download.png" alt="whitepaper download" style="width: 26px; margin: -6.5px 10px 0 0;"> 現在下載</a>';
      }

      var OSName="Unknown OS";
        if (navigator.appVersion.indexOf("Win")!=-1){
          OSName="Windows";
          $("#MacMSWordButton").css("display", "none");
        }
        if (navigator.appVersion.indexOf("Mac")!=-1){
          OSName="MacOS";
          $("#MSWindowDownloadButton").css("display", "none");
          $("#MSWindowTextContent").css("display", "none");
          $("#MacMSWordButton").css("display", "block");
        } 
        if (navigator.appVersion.indexOf("X11")!=-1){
          OSName="UNIX";
          $("#MacMSWordButton").css("display", "none");
        }
        if (navigator.appVersion.indexOf("Linux")!=-1){
          OSName="Linux";
          $("#MacMSWordButton").css("display", "none");
        }
    }
    ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()})
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/home_client_slider.js', function () { });
      $.getScript('../../../assets/js/about_us_testimonial_silders.js', function () { });
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/8dmdUUvVj3Q" width="100%" height="450"></iframe>');
        }
      });

    }
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
